// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadButton-cls1_eMt","cls2":"DownloadButton-cls2_18y DownloadButton-cls1_eMt"};